import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import HeaderDropdown from '../headerDropdown';
import SimpleHeader from '../../headers/simpleHeader';
import IntegrationCards from './IntegrationCards';

const IntegrationsPage = ({ baseUrl, ecommerceIntegrationEnabled, mailchimpIntegrationEnabled }) => (
  <div className="c-wrapper integrations o-flexbox o-flexbox--content-align-center o-flexbox--justify-center">
    <SimpleHeader heading={t('settings:integrations.page.brand_settings')}>
      <HeaderDropdown title={t('settings:integrations.page.integrations')} />
    </SimpleHeader>
    <IntegrationCards
      baseUrl={baseUrl}
      ecommerceIntegrationEnabled={ecommerceIntegrationEnabled}
      mailchimpIntegrationEnabled={mailchimpIntegrationEnabled}
    />
  </div>
);

IntegrationsPage.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  ecommerceIntegrationEnabled: PropTypes.bool.isRequired,
  mailchimpIntegrationEnabled: PropTypes.bool.isRequired,
};

IntegrationsPage.defaultProps = {
  children: undefined,
};

export default IntegrationsPage;
